export * from '@primeuix/themes/aura/overlaybadge';
export { default } from '@primeuix/themes/aura/overlaybadge';
